
import Vue from 'vue'
import AsyncTasksNotification from '@/components/generic/AsyncTasksNotification.vue'

export default Vue.extend({
  components: {
    AsyncTasksNotification
  }
})
